import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVatSettlement, closeVatSettlement, getWorkspaceSettlement } from "../../../store/actions/reports/vatSettlement";
import DetailSummary from "./detailSummary";
import TableComplex from "../../vapor/tableComplex";
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import VatLineRow from "./vatLineRow";
import moment from "moment";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage, useIntl } from "react-intl";
import { openNotificationWithIcon, isNumeric } from "../../../libs/utils";
import { notification } from "antd";
import { useLocation } from "react-router";

/*
const monthToNumber = {
  "JANUARY":0,
  "FEBRUARY":1,
  "MARCH":2,
  "APRIL":3,
  "MAY":4,
  "JUNE":5,
  "JULY":6,
  "AUGUST":7,
  "SEPTEMBER":8,
  "OCTOBER":9,
  "NOVEMBER":10,
  "DECEMBER":11
};
*/

const VatDetailReportPage = ({currentSettlmentInfo, currentMonthSelected, setSubtitleSection, businessId, selectedYear}) => {
  const reportVatStatus = useSelector(state => state.reports.vat.statusDetail);
  const settlementDetail = useSelector(state => state.reports.vat.detail);
  const settlementsList = useSelector(state => state.reports.vat?.settlements?.settlementApiResList);
  const [activityTotals, setActivityTotals] = useState([]);
  const [currentSettlement, setCurrentSettlement] = useState({});
  const [monthNumber, setMonthNumber] = useState(null);
  const [disableButton, setDisableButton] = useState(true);  
  const dispatch = useDispatch();
  const intl = useIntl();
  const location = useLocation();

  useEffect(() => {
    if (currentSettlement?.businessDescription)
      setSubtitleSection(intl.formatMessage({id: "reports.vat.activityDetail.detail"})+" " + currentSettlement.businessDescription);
  }, [currentSettlement]);

  useEffect(() => {
    if (!location && !location.state) return;        
      
    setDisableButton(location?.state ? !location?.state?.enableConsolidate : !currentSettlmentInfo?.state?.enableConsolidate);  
    const currentMonthNumber = currentMonthSelected ? currentMonthSelected : location.pathname.split("vat-detail/")[1];
    const currentMonth = isNumeric(currentMonthNumber) ? moment(currentMonthNumber, "M").locale("en").format("MMMM") : currentMonthNumber;
    const currentYear = selectedYear ? selectedYear : location?.state?.year;
    setMonthNumber(currentMonthNumber);
    dispatch(getVatSettlement(
      businessId, currentYear, currentMonth
    ));
  }, [location, currentMonthSelected, selectedYear]);

  useEffect(() => {
    if (!settlementDetail) return;
    setCurrentSettlement(settlementDetail[0]);
  }, [settlementDetail]);

  useEffect(() => {
    let totals = [];    
    if (currentSettlement?.details) {    
      currentSettlement.details.forEach(el => {
        let taxableTotal = 0;
        let taxTotal = 0;
        let nonDeductibleTotal = 0;
        el?.aliquotes?.map(el => { taxableTotal = taxableTotal + el.taxable; taxTotal = taxTotal + el.tax; nonDeductibleTotal = nonDeductibleTotal + el?.nonDeductibleAmount; });
        totals.push({ description: el.description.toLowerCase(), taxableTotal: taxableTotal, taxTotal: taxTotal, total: taxableTotal + taxTotal, nonDeductibleTotal: nonDeductibleTotal });
      });
    }
    setActivityTotals(totals);
  }, [currentSettlement, currentMonthSelected]);

  let columnsSettlement = [
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.description"}),
      width: "25%",
      dataIndex: "description",
      key: "description"
    },
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.rateExemption"}),
      width: "16%",
      dataIndex: "aliquote",
      key: "aliquote"          
    },
    {
      title:intl.formatMessage({id: "reports.vat.activityDetail.rateDescription"}),
      width: "16%",
      dataIndex: "aliquoteDesc",
      key: "aliquoteDesc"
    },
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.taxable"}),
      width: "10%",
      dataIndex: "taxable",
      key: "taxable"
    },
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.tax"}),
      width: "10%",
      dataIndex: "tax",
      key: "tax"
    },
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.nonDeductibleAmount"}),
      width: "10%",
      dataIndex: "nonDeductibleAmount",
      key: "nonDeductibleAmount"
    },
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.total"}),
      width: "10%",
      dataIndex: "total",
      key: "total"
    },
    {
      title: "",
      width: "3%",
      dataIndex: "detail",
      key: "detail"
    }
  ];

  const onClickClose = () =>{
    setDisableButton(true);
    const currentMonthNumber = currentMonthSelected ? currentMonthSelected :location.pathname.split("vat-detail/")[1];
    const currentMonth = isNumeric(currentMonthNumber) ? moment(currentMonthNumber, "M").locale("en").format("MMMM").toUpperCase() : currentMonthNumber.toUpperCase();
    dispatch(closeVatSettlement(
      businessId, location?.state?.year || currentSettlmentInfo.state?.year, currentMonth
    ))
      .then(res => {
        dispatch(getWorkspaceSettlement(selectedYear));
        setDisableButton(true);
      })
      .catch(err=>{
        openNotificationWithIcon(
          notification,
          "error",
          "",
          "Si è verificato un errore",
          null,
          null
        );
      });
  };

  const buildDataSource = () => {
    return currentSettlement?.details?.map((vatLine, key) => renderTableRow(vatLine, key));
  };

  const renderTableRow = (vatLine, key) => {    
    // https://teamsystem.atlassian.net/browse/DOP-1726
    if (["SALE", "PURCHASE"].includes(vatLine.description.toUpperCase())){    
      const currentTotals = activityTotals.find(el => el.description === vatLine.description.toLowerCase());    
      return {
        key: key,
        vatLine: vatLine,
        description: <b><FormattedMessage id={`reports.vat.${vatLine.description}`} /></b>,
        aliquote: <div></div>,
        aliquoteDesc: <div></div>,
        taxable: <div><b>{`${numeral(Math.abs(currentTotals?.taxableTotal)).format("0,0.00")} €`}</b></div>,
        tax: <div><b>{`${numeral(Math.abs(currentTotals?.taxTotal)).format("0,0.00")} €`}</b></div>,
        nonDeductibleAmount: <div><b>{`${numeral(Math.abs(currentTotals?.nonDeductibleTotal)).format("0,0.00")} €`}</b></div>,
        total: <div><b>{`${numeral(Math.abs(currentTotals?.total)).format("0,0.00")} €`}</b></div>,
        detail: <div></div>
      };
    }
    
    return null;
    
  };

  return reportVatStatus?.started ? 
    <div style={{margin: "35px -18px",
      height: "235px",
      display: "flex",
      color: "#0090d1",
      alignItems: "center",
      justifyContent: "center",
      width: "calc(100% + 35px)",
      position: "relative"}}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} style={{ fontSize: "34px" }} spin />
    </div> 
    :
    (
      <div className="vatHeader">
        <DetailSummary activityTotals={activityTotals} currentSettlement={location?.state?.settlement?.businessSettlements?.[0] ? location?.state?.settlement?.businessSettlements?.[0] : currentSettlement} monthNumber={monthNumber} selectedYear={selectedYear} />
        <TableComplex
          columns={columnsSettlement}
          dataSource={buildDataSource()}
          expandable={{
            rowExpandable: record => record?.vatLine?.aliquotes?.length > 0,
            expandIcon: ({ expanded, onExpand, record }) => 
              record?.vatLine?.aliquotes?.length > 0 &&
              <div style={{ padding: "8px" }} onClick={e => onExpand(record, e)}>
                <FontAwesomeIcon
                  icon={[
                    "fas",
                    expanded ? "chevron-down" : "chevron-right"
                  ]}

                  className="expandVatLineArrow"
                /></div>,
            expandedRowRender: (record, index) => record.vatLine?.aliquotes.map(line => <VatLineRow journalType={record.vatLine?.description} line={line} key={index} currentSettlement={currentSettlement} monthNumber={monthNumber} />)
          }}
        />  
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingTop: 50
          }}
        >
          {settlementsList && !(settlementsList[currentMonthSelected]?.closed) && !(settlementsList[currentMonthSelected]?.businessSettlements.length > 1) ? 
            <Button kind="primary" onClick={()=>onClickClose()} disabled={disableButton}>
            Consolida
            </Button>
            : null
          }
        </div>
      </div>
    );
};
export default VatDetailReportPage;
